/**
 * Constantes de couleurs du thème Travel Manager
 * Centralise toutes les couleurs de l'application pour faciliter la maintenance
 */

// Couleur principale du thème (from App.css)
export const THEME_COLORS = {
  PRIMARY: '#074E71',
  PRIMARY_DARK: '#053A5A',
  PRIMARY_LIGHT: '#E8F1F7',
  PRIMARY_SUBTLE: 'rgba(7, 78, 113, 0.05)',
  PRIMARY_HOVER: 'rgba(7, 78, 113, 0.1)',
  PRIMARY_BORDER: 'rgba(7, 78, 113, 0.2)',
  
  // Couleurs secondaires
  ACCENT: '#FFBA00', // Jaune des onglets (from App.css)
  SUCCESS: '#28a745',
  WARNING: '#ffc107',
  ERROR: '#dc3545',
  INFO: '#17a2b8',
  
  // Couleurs neutres
  WHITE: '#ffffff',
  LIGHT_GRAY: '#f8f9fa',
  GRAY: '#6c757d',
  DARK_GRAY: '#343a40',
  BORDER: '#dee2e6',
  
  // Couleurs de statut
  POSITIVE: '#28a745',
  NEGATIVE: '#dc3545',
  NEUTRAL: '#6c757d'
};

// Variables CSS pour utilisation dans les composants styled
export const CSS_VARIABLES = {
  '--theme-primary': THEME_COLORS.PRIMARY,
  '--theme-primary-dark': THEME_COLORS.PRIMARY_DARK,
  '--theme-primary-light': THEME_COLORS.PRIMARY_LIGHT,
  '--theme-primary-subtle': THEME_COLORS.PRIMARY_SUBTLE,
  '--theme-primary-hover': THEME_COLORS.PRIMARY_HOVER,
  '--theme-accent': THEME_COLORS.ACCENT,
  '--theme-border': THEME_COLORS.BORDER
};

// Styles prêts à utiliser pour les composants
export const THEME_STYLES = {
  primaryButton: {
    backgroundColor: THEME_COLORS.PRIMARY,
    color: THEME_COLORS.WHITE,
    border: `1px solid ${THEME_COLORS.PRIMARY}`,
    borderRadius: '4px',
    padding: '8px 16px',
    fontWeight: 'bold'
  },
  
  secondaryButton: {
    backgroundColor: 'transparent',
    color: THEME_COLORS.PRIMARY,
    border: `1px solid ${THEME_COLORS.PRIMARY}`,
    borderRadius: '4px',
    padding: '8px 16px',
    fontWeight: 'bold'
  },
  
  tableHeader: {
    backgroundColor: THEME_COLORS.PRIMARY,
    color: THEME_COLORS.WHITE,
    textAlign: 'center',
    fontWeight: 'bold',
    padding: '12px 8px'
  },
  
  tableTotal: {
    backgroundColor: THEME_COLORS.PRIMARY,
    color: THEME_COLORS.WHITE,
    fontWeight: 'bold',
    borderTop: `2px solid ${THEME_COLORS.PRIMARY_DARK}`
  },
  
  percentageCell: {
    textAlign: 'center',
    color: THEME_COLORS.PRIMARY,
    backgroundColor: THEME_COLORS.PRIMARY_SUBTLE,
    fontWeight: '500'
  }
};

export default THEME_COLORS;
